/**
 * Numărătoarea inversă de la extragere (overlay-ul #countdown-container din index.html) + sunetele ei.
 * Folosită și de extragerea clasică (claims.js), și de tombola cu premii pe locuri (legal-draw.js).
 */
export const DRAW_COUNTDOWN_SECONDS = 10;

function getDrawCountdownText(sec) {
  if (sec >= 8) return 'Se verifică participanții eligibili...';
  if (sec >= 5) return 'Se rulează selecția aleatorie...';
  if (sec >= 2) return 'Se finalizează extragerea...';
  return 'Pregătește-te!';
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function playCountdownTick() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'square';
    osc.frequency.value = 980;
    gain.gain.setValueAtTime(0.06, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.05);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.05);
    setTimeout(() => ctx.close().catch(() => {}), 120);
  } catch (e) {
    // silent fail
  }
}

function playCountdownFinal() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(620, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(980, ctx.currentTime + 0.2);
    gain.gain.setValueAtTime(0.12, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.22);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.22);
    setTimeout(() => ctx.close().catch(() => {}), 250);
  } catch (e) {
    // silent fail
  }
}

/**
 * Afișează numărătoarea (secunde -> 1), apoi ascunde overlay-ul.
 * @param {number} seconds
 * @param {() => boolean} [shouldStop] - dacă întoarce true (ex. extragerea a eșuat pe server), se oprește imediat.
 */
export async function runDrawCountdown(seconds = DRAW_COUNTDOWN_SECONDS, shouldStop = null) {
  const overlay = document.getElementById('countdown-container');
  const numberEl = document.getElementById('countdown-number');
  const textEl = document.getElementById('countdown-text');
  if (!overlay || !numberEl || !textEl) return;

  overlay.classList.add('show');

  for (let sec = seconds; sec >= 1; sec -= 1) {
    if (typeof shouldStop === 'function' && shouldStop()) break;
    numberEl.textContent = String(sec);
    textEl.textContent = getDrawCountdownText(sec);

    // retrigger pulse animation each second
    numberEl.style.animation = 'none';
    void numberEl.offsetWidth;
    numberEl.style.animation = '';

    if (sec > 1) playCountdownTick();
    else playCountdownFinal();

    await wait(1000);
  }

  if (!(typeof shouldStop === 'function' && shouldStop())) await wait(400); // scurtă pauză înainte de dezvăluire
  overlay.classList.remove('show');
}
